import { Stack, Box } from "@mui/material"
import Check from "./Check";
import { useNavigate, useParams } from "react-router-dom";
import { txt } from "../../../services/translation";
import isScreenSmall from "../isScreenSmall";
import useStore from "../Hooks/useStore";

export default function Section({section}){

    const navigate = useNavigate();

    const {setNav} = useStore()

    const {course, tab} = useParams();

    const handleClick = () => {

        if(isScreenSmall()) setNav(false);

        navigate(`/study/${course}/${section.id}`)
    }

    const active = section.id === tab;

    const className = 'study-section' + (active ? ' study-section-active' : '')

    const durationText = section.duration ? ('- ' + Math.ceil(section.duration / 60) + ' min') : false;

    return <article className={className} data-id={section.id} onClick={handleClick}>

            <Stack direction='row' alignItems='center' spacing={3}>

                <Check value={section.completed}/>
                
                <Box>
                    {section.title}
                    <br/>
                    <small>
                        {txt(section.type?.id + 'Label')} {durationText} 
                        {false && <Note note={section.note} />}
                    </small>
                </Box>

            </Stack>
                
        </article>

}


function Note({note}){

    return note && <span>&#9998;</span>
}